// extracted by mini-css-extract-plugin
export default {"app":"app_app__ZSdIq","btns_box":"app_btns_box__9L754","btn1":"app_btn1__IJAQM","btn2":"app_btn2__Jzdkx","btn3":"app_btn3__-Nz14","circlex_box":"app_circlex_box__00ywC"};